import { render, staticRenderFns } from "./HighlightedOtherServicesNew.vue?vue&type=template&id=2c55ee64&scoped=true&"
import script from "./HighlightedOtherServicesNew.vue?vue&type=script&lang=js&"
export * from "./HighlightedOtherServicesNew.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedOtherServicesNew.vue?vue&type=style&index=0&id=2c55ee64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c55ee64",
  null
  
)

export default component.exports